import { atom } from 'jotai';
import type { PrimitiveAtom } from 'jotai';

export const isThemeLoadingAtom = atom<boolean>(false) as PrimitiveAtom<boolean>;
export const isProductsLoadingCompleteAtom = atom<boolean>(false) as PrimitiveAtom<boolean>;

export const resetThemeStateAtom = atom(null, (get, set) => {
  set(isThemeLoadingAtom, false);
  set(isProductsLoadingCompleteAtom, false);
});
